const severityToColor = severity => {
  const s = severity?.toLowerCase();
  if (s === "high") return "red";
  if (s === "medium") return "amber";
  return "green";
};

const priorityToColor = priority => {
  const p = priority?.toLowerCase();
  if (p === "high") return "amber";
  if (p === "medium") return "green";
  return "gray";
};

export const mapAiNotes = (raw = {}) => {
  const painPointItems = (raw.painPoints || []).map(p => ({
    cat: "Pain point",
    color: severityToColor(p.severity),
    text: p.painPoint
  }));
  const requirementItems = (raw.requirements || []).map(r => ({
    cat: "Requirement",
    color: priorityToColor(r.priority),
    text: r.requirement
  }));
  const buyingSignalItems = (raw.buyingSignals || []).map(b => ({
    cat: "Buying signal",
    color: "green",
    text: b.signal
  }));

  return {
    summary: raw.conversationSummary?.shortSummary || "",
    sentiment: raw.conversationSummary?.overallSentiment || "",
    keyPoints: [...painPointItems, ...requirementItems, ...buyingSignalItems],
    objections: (raw.objections || []).map(o => ({
      label: o.objection,
      desc: o.suggestedHandling
    })),
    nextSteps: (raw.nextBestSteps || []).map(n => n.step),
    actionItems: raw.actionItems || [],
    topics: raw.topicsDiscussed || []
  };
};

export const mapTranscriptLines = (transcripts = []) => {
  if (!transcripts.length) return [];
  const firstTs = new Date(transcripts[0].createTs).getTime();
  return transcripts.map(t => {
    const offsetMs = new Date(t.createTs).getTime() - firstTs;
    const totalSec = Math.floor(offsetMs / 1000);
    const m = Math.floor(totalSec / 60);
    const s = totalSec % 60;
    const time = `${m}:${s.toString().padStart(2, "0")}`;
    const isRep = t.speaker === "0" || t.speaker?.toLowerCase() === "rep";
    return {
      s: isRep ? "rep" : "prospect",
      name: isRep ? "Rep" : "Prospect",
      time,
      text: t.transcript
    };
  });
};
